import React from "react";
import { Modal, ModalBody } from "reactstrap";
import Text from "components/Text";
import Button from "components/Button";
import { Trans, withTranslation } from "react-i18next";
import crossIcon from "assets/images/cross.svg";
import styles from "../../Notes/Notes.module.scss";
import Loader from "components/Loader";

const ConfirmationPopup = ({
  t,
  isModalOpen,
  closeModal,
  handleConfirm,
  id,
  loader,
  eventKey,
}) => {
  return (
    <Modal
      isOpen={isModalOpen}
      toggle={closeModal}
      className="modal-lg modal-dialog-centered"
      modalClassName="custom-modal"
    >
      {loader && <Loader />}
      <span className="close-btn" onClick={closeModal}>
        <img src={crossIcon} alt="close" />
      </span>
      <ModalBody>
        <div>
          <Text
            size="25px"
            weight="500"
            color="#111B45"
            lineHeight="25px"
            align="center"
            marginTop="20px"
          >
            {t("scheduler.confirmationTitle")}
          </Text>
          <Text
            size="16px"
            weight="300"
            color="#535B5F"
            marginTop="11px"
            lineHeight="24px"
            align="center"
          >
            <Trans
              i18nKey={`scheduler.${id}`}
              values={eventKey}
              components={{ strong: <strong style={{ fontWeight: 600 }} /> }}
            />
          </Text>

          <div className={styles.confirmation_btn_container}>
            <Button onClick={handleConfirm}>{t("scheduler.confirm")}</Button>
            <Button borderedSecondaryNew onClick={closeModal}>
              <span>{t("cancel")}</span>
            </Button>
          </div>
        </div>
      </ModalBody>
    </Modal>
  );
};
export default withTranslation()(ConfirmationPopup);
